import bg_home from 'assets/images/bg_home.png';
import HeaderMenu from 'components/Header/HeaderMenu';
import { SITE } from 'config/config';
import { useEffect, useState } from 'react';
import { getAllSetting } from 'service/base';
import { SETTING_KEYS } from 'utils/common/const';

const RuleFixPage = () => {
  const [dataSettings, setDataSettings] = useState([]);

  useEffect(() => {
    fetchAllSetting();
  }, []);

  const fetchAllSetting = async () => {
    try {
      const res = await getAllSetting({ site: SITE });
      setDataSettings(res?.data || []);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  console.log('dataSettings', dataSettings);

  return (
    <div className="w-full h-full">
      <img
        src={bg_home}
        alt="Background"
        className="h-full w-full fixed right-0 bottom-0 object-cover"
      />
      <div className="relative z-10 pb-5">
        <HeaderMenu />
        <div className="container relative z-10">
          <div className="w-full max-w-[1200px] mx-auto h-auto flex justify-center items-center">
            <img
              src="/assets/images/header/bannerpc.png"
              alt=""
              className="w-full h-auto object-contain md:flex hidden"
            />
            <img
              src="/assets/images/header/bannermb.png"
              alt=""
              className="w-full h-auto object-contain py-2 md:hidden flex"
            />
          </div>
          <div
            className="mx-auto bg-white/95 border-solid border-[#006719] border-[6px] rounded-3xl shadow shadow-primary p-2 md:pb-8 md:pt-4 md:px-10
                w-full"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: dataSettings?.find((item) => item.key === SETTING_KEYS.RULE)?.content
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RuleFixPage;
